// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3RJ2i","emails":"CreateEditClinics_emails__1Awxc","emailTagLabel":"CreateEditClinics_emailTagLabel__2VCK-"};